export const SHARE_SOCIETE_POINTS_BY_VARIANT: Record<string, number> = {
  variant_10: 10,
  variant_50: 50,
}

export const PHONE_POINTS_CONFIG = {
  control: { points: 0, earnKey: 'pt=all&c=phoneadded' },
  variant_50: { points: 50, earnKey: 'pt=all&c=phoneadded50' },
  variant_500: { points: 500, earnKey: 'pt=all&c=phoneadded500' },
} as const
